/**
 * Helper para manejar la conversión y guardado de studyModality
 * Centraliza la lógica en un solo lugar para evitar duplicación
 */

/**
 * Convierte studyModality a string y lo guarda en el store si es válido
 * @param studyModality - Valor de studyModality (puede ser number o string)
 * @param updateStudyModality - Función del store para actualizar
 * @param source - Identificador de dónde se llama (para logs)
 * @returns true si se guardó, false si no
 */
export function saveStudyModality(
    studyModality: string | number | null | undefined,
    updateStudyModality?: (value: string) => void,
    source?: string
): boolean {
    // Validar que tengamos un valor y la función de actualización
    if (
        studyModality === null ||
        studyModality === undefined ||
        !updateStudyModality
    ) {
        if (process.env.NODE_ENV === 'development' && source) {
            console.log(
                `⚠️ [${source}] studyModality no guardado:`,
                studyModality === null || studyModality === undefined
                    ? 'valor nulo'
                    : 'sin función de actualización'
            )
        }

        return false
    }

    // Convertir a string para consistencia
    const studyModalityString = String(studyModality)

    // Log solo en desarrollo
    if (process.env.NODE_ENV === 'development' && source) {
        console.log(
            `💾 [${source}] Guardando studyModality: ${studyModality} → "${studyModalityString}"`
        )
    }

    updateStudyModality(studyModalityString)

    return true
}

/**
 * Valida si un valor es un studyModality válido
 */
export function isValidStudyModality(
    value: string | number | null | undefined
): value is string | number {
    return value !== null && value !== undefined && value !== ''
}
